import { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { ChartContainer } from '../../../../../../common/chart/chartContainer'
import Bar from '../../../../../../common/chart/chartContainer/Bar'
import Line from '../../../../../../common/chart/chartContainer/Line'
import { Legend } from '../../../../../../common/chart/legend'
import { Element } from '../../../../../../common/html/element'
import { SCREEN } from '../../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { getUnique } from '../../../../../../helpers/common'
import { selectUserType } from '../../../../../../layout/store/slice'
import { USER_TYPE } from '../../../../../../utils/authorization'
import { getValueAndTitleCheckbox } from '../../../helper'
import classes from '../../../index.module.scss'
import { changeChecked, selectChecked } from '../../../store/slice'
import { selectDataViewByTrend, selectIndicatorById } from '../store/slice'
import {
  convertData,
  isInValidValue,
  valToPercent,
} from './../../../../../../helpers/value'
import { RATIO_CODE, TREND_QUALITY_DATA } from './constant'

const Quality = ({ id, check, isDynamicReport }) => {
  const chartId = useRef(getUnique())

  const dispatch = useDispatch()
  const locale = useSelector((state) => state.i18n.locale)
  const userType = useSelector(selectUserType)
  const {
    formatedUnit,
    getExchangeRate,
    multiplier,
    formatValueWithUnit,
    decimalLength,
  } = useFormatCurrency(SCREEN.FINANCIAL_ANALYSIS)
  const dataByTrend = useSelector(selectDataViewByTrend)
  const indicatorById = useSelector(selectIndicatorById)
  const checkedStore = useSelector(selectChecked(id))

  const checked = checkedStore || check

  const checkboxs = TREND_QUALITY_DATA.map((item) => ({
    ...item,
    ...getValueAndTitleCheckbox(indicatorById, item.value),
  }))

  const handleSetChecked = (checked) => {
    if (checkboxs.some((checkbox) => checked.includes(checkbox.value))) {
      dispatch(changeChecked({ id, checked }))
    }
  }
  const dataConvert = convertData(
    dataByTrend,
    getExchangeRate,
    indicatorById,
    multiplier,
    ['year'],
    [RATIO_CODE.NPL_RATIO, RATIO_CODE.SPECIAL_MENTION_AND_NPL],
  )

  const bars = checkboxs.filter(
    (item) => item.isBarChart && checked.includes(item.value),
  )
  const groupStackBarKeys = bars.map((bar) => bar.value)

  const lines = checkboxs.filter(
    (item) => item.isLineChart && checked.includes(item.value),
  )

  const isNotHasBar = !bars.length

  return (
    <div className={`h100 ${!isDynamicReport ? 'flexColumn' : 'dFlex'}`}>
      <div className={`h100 ${!isDynamicReport ? 'w100' : 'w70'} flexColumn`}>
        <div className="fw600">
          <Translate value="financialAnalysis.LOAN_PORTFOLIO_BY_QUALITY" />
        </div>
        <Element style={{ color: '#9C9C9C' }} className="pt1">
          {!isNotHasBar ? formatedUnit : <>&nbsp;</>}
        </Element>
        <div className="h100 pt1">
          <ChartContainer
            chartId={chartId.current}
            data={dataConvert}
            margin={{
              top: 10,
              bottom: 0,
              left: isNotHasBar || isDynamicReport ? 16 : 0,
              right: isDynamicReport ? 16 : 0,
            }}
            width="100%"
            height="100%"
            xAxis={[{ dataKey: 'year', height: 30 }]}
            yAxis={[
              {
                yAxisId: 'left',
                dataKeys: bars.map((item) => item.value),
                isStackedBar: true,
                hide: isNotHasBar,
                decimalLength,
              },
              {
                yAxisId: 'right',
                orientation: 'right',
                dataKeys: lines.map((item) => item.value),
                isLineChart: true,
                unit: '%',
              },
            ]}
            tooltip={{
              schema: {
                content: [
                  ...bars.map((bar) => ({
                    dataKey: bar.value,
                    label: bar.title,
                    formatValue: (value) => formatValueWithUnit({ value }),
                  })),
                  ...lines.map((line) => ({
                    dataKey: line.value,
                    label: line.title,
                    formatValue: (value) => valToPercent(value, locale, true),
                  })),
                ],
              },
            }}
          >
            {bars.map((bar, barIndex) => (
              <Bar
                key={bar.value}
                yAxisId="left"
                dataKey={bar.value}
                stackId="stackBar"
                fill={bar.color}
                maxBarSize={35}
                showLabelEmpty={({ index }) =>
                  barIndex === 0 &&
                  groupStackBarKeys.every((dataKey) =>
                    isInValidValue(dataConvert[index][dataKey]),
                  )
                }
              />
            ))}
            {lines.map((line) => (
              <Line
                key={line.value}
                yAxisId="right"
                dataKey={line.value}
                stroke={line.color}
              />
            ))}
          </ChartContainer>
        </div>
      </div>
      {!isDynamicReport ? (
        <div className={`pt1 dFlex ${classes.footerContainer}`}>
          <div className={classes.w50}>
            <Legend
              chartId={chartId.current}
              items={checkboxs.slice(0, 5).map((item) => ({
                title: item.title,
                value: item.value,
                dataKey: item.value,
                color: item.color,
                isCheckbox: userType?.userTypeId === USER_TYPE.PREMIUM,
                listCheckBox: checked,
                setListCheckBox: handleSetChecked,
                isI18n: false,
              }))}
              className="flexColumn"
            />
          </div>
          <div className={classes.w50}>
            <Legend
              chartId={chartId.current}
              items={checkboxs.slice(5).map((item) => ({
                title: item.title,
                value: item.value,
                dataKey: item.value,
                color: item.color,
                isCheckbox: userType?.userTypeId === USER_TYPE.PREMIUM,
                listCheckBox: checked,
                setListCheckBox: handleSetChecked,
              }))}
              className="flexColumn"
            />
          </div>
        </div>
      ) : (
        <div
          className={`dFlex ${classes.footerContainer} alignItemsCenter pl4`}
        >
          <div className="w100">
            <Legend
              chartId={chartId.current}
              items={checkboxs.map((item) => ({
                title: item.title,
                value: item.value,
                dataKey: item.value,
                color: item.color,
                isCheckbox: userType?.userTypeId === USER_TYPE.PREMIUM,
                listCheckBox: checked,
                setListCheckBox: handleSetChecked,
                isDynamicReport: isDynamicReport,
              }))}
              className="flexColumn"
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default Quality
